export default __webpack_public_path__ + "static/media/covidapp.52e04f9a.svg";